import type { ExportResult } from "@opentelemetry/core";
import { ExportResultCode } from "@opentelemetry/core/build/src/ExportResult";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-proto";
import type { ReadableSpan } from "@opentelemetry/sdk-trace-web";
export class OTLPTraceExporterWithXhrFallback extends OTLPTraceExporter {
    private readonly xhrTraceExporter: OTLPTraceExporter;
    constructor(config?: ConstructorParameters<typeof OTLPTraceExporter>[0]) {
        if (config?.headers !== undefined) {
            // If there are headers, then the base class won't use sendBeacon, at which point there is simply no need for this sub-class.
            throw new Error("OTLPTraceExporterBrowserWithXhrRetry assumes that the configuration doesn't have headers.");
        }
        super(config);
        this.xhrTraceExporter = new OTLPTraceExporter({
            ...config,
            // Passing in custom headers forces the exporter to use XHR, because sendBeacon doesn't support headers. See https://github.com/open-telemetry/opentelemetry-js/issues/3489#issuecomment-2474252180
            headers: {},
        });
    }
    export(items: ReadableSpan[], resultCallback: (result: ExportResult) => void): void {
        super.export(items, (result) => {
            // Assumption: The base class will always use sendBeacon.
            // A failure here indicates a sendBeacon failure, which is most likely due to a payload size that is greater than 65536 bytes.
            // These can be retried as XHR requests.
            if (result.code === ExportResultCode.FAILED) {
                this.xhrTraceExporter.export(items, resultCallback);
            }
            else {
                resultCallback(result);
            }
        });
    }
}
